var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInvoice(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 6h18H1zm4 5h1-1zm5 0h1-1zm-6 4h12a3 3 0 003-3V4a3 3 0 00-3-3H4a3 3 0 00-3 3v8a3 3 0 003 3z",
    stroke: "#4A5568",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default __webpack_public_path__ + "static/media/invoice.e7fc5c26.svg";
export { SvgInvoice as ReactComponent };